/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GcpPolicyResponse } from './gcpPolicyResponse';
import { GcpArtifactRepositoryImageResponse } from './gcpArtifactRepositoryImageResponse';


export interface GcpArtifactRepositoryResponse { 
    /**
     * Name of artifact registry repository
     */
    repository_name?: string;
    /**
     * Repository location/region
     */
    location?: string;
    /**
     * Images inside this repository
     */
    images?: Array<GcpArtifactRepositoryImageResponse>;
    policy?: GcpPolicyResponse;
}

